/**
 * Reload a page the browser restores from its back/forward cache when the
 * signed-in user changed while it was away.
 *
 * "Log ind som" (and logging back, and logging out) stores the new token and
 * navigates away. Pressing Back then brings the old page back from the cache
 * exactly as it was — still showing the administrator's screens and data —
 * but every request it sends now carries the other user's token, because
 * axios's header was switched just before navigating. A Frederiksberg
 * administrator, back on user administration after logging in as a student,
 * wrote a note and got "Unauthorized" (2026-10-12): the note went out as the
 * student.
 *
 * A restored page whose token no longer matches the one it started with is
 * reloaded, so it shows what the current user may actually see.
 */
export function installStaleSessionReload(win = window, storage = window.localStorage) {
    const tokenAtStart = readToken(storage)

    win.addEventListener('pageshow', event => {
        if (event.persisted && readToken(storage) !== tokenAtStart) {
            win.location.reload()
        }
    })
}

function readToken(storage) {
    try {
        return storage.getItem('id_token')
    } catch (e) {
        return null
    }
}
